import { useState, createContext, useContext, useEffect } from "react";
import type { ReactNode } from "react";
import usePrefStore from "../stores/prefs"
import useTarifs from '../Hooks/useTarifs';
import { registerSW } from 'virtual:pwa-register'
import glob_const from "../libs/glob_const";
import { setRegistration, watchNewVersions } from "../libs/pwaUpdate";
import type { GlobalContextValue, TarifCurrencies } from "../types";

const theContext = createContext<GlobalContextValue | undefined>(undefined)

const GlobalContext = (() => useContext(theContext)!)

const GlobalContextProvider = ({ children }: { children: ReactNode }) => {
   const [isDarkLayerVisible, setIsDarkLayerVisible] = useState(false)
   const [isSyncLayerVisible, setIsSyncLayerVisible] = useState(false)
   const [isOtpLayerVisible, setIsOtpLayerVisible] = useState(false)
   const [isMissingTarifLayerVisible, setIsMissingTarifLayerVisible] = useState(false)
   const [isListRecentCustomersVisible, setIsListRecentCustomersVisible] = useState(false)
   const [isListRecentOrdersVisible, setIsListRecentOrdersVisible] = useState(false)
   const [isWebSocketConnected, setIsWebSocketConnected] = useState(false)
   const [keepSearchBarAccessible, setKeepSearchBarAccessible] = useState(false)
   const [curTarif, setCurTarif] = useState<TarifCurrencies | null>(null)
   const [allLogs, setAllLogs] = useState(null)    // Si null, on ne garde pas les logs
   const [lastStackDump, setLastStackDump] = useState(null)    // Pour éviter de faire des stack dumps (vers serveur) trop fréquents
   //
   const { curTarifRegionName } = usePrefStore();
   //
   const { getTarifsForRegion } = useTarifs();

   useEffect(() => {
      setCurTarif(getTarifsForRegion(curTarifRegionName))
   }, [curTarifRegionName, getTarifsForRegion])

   useEffect(() => {
      let timer: ReturnType<typeof setInterval> | undefined

      // messika-pwa#34 : une nouvelle version n'est plus rechargée d'office. Le SW (skipWaiting) prend la main,
      // watchNewVersions décide : rechargement au démarrage / après synchro, bandeau en cours de session.
      const stopWatching = watchNewVersions()

      registerSW({
         onRegistered(r) {
            console.log('**SW++ 1 onRegistered', r);
            setRegistration(r)
            if (r) {
               r.update()  // Un check immédiat
               timer = setInterval(() => {
                  r.update()
               }, glob_const.check_sw_update_delay)      // Un check toutes les 15min
               console.log('**SW++ 1 setInterval', timer);
            }
         },
         onNeedRefresh() {
            console.log('**SW++ 1 onNeedRefresh (pris en charge par watchNewVersions)');
         },
         onOfflineReady() {
            console.log('**SW++ 1 onOfflineReady');
         },
      })

      return () => {
         console.log('**SW++ 1 clearInterval', timer);
         clearInterval(timer)
         stopWatching()
      }
   }, [])

   return (
      <theContext.Provider value={{ isDarkLayerVisible, setIsDarkLayerVisible, isSyncLayerVisible, setIsSyncLayerVisible, isOtpLayerVisible, setIsOtpLayerVisible, keepSearchBarAccessible, setKeepSearchBarAccessible, isListRecentCustomersVisible, setIsListRecentCustomersVisible, isListRecentOrdersVisible, setIsListRecentOrdersVisible, curTarif, allLogs, setAllLogs, lastStackDump, setLastStackDump, isWebSocketConnected, setIsWebSocketConnected, isMissingTarifLayerVisible, setIsMissingTarifLayerVisible }}>
         {children}
      </theContext.Provider>
   )
}

export { GlobalContext, GlobalContextProvider }
